export enum EExpenseType {
  INCREMENT = 'increment',
  WATER = 'water',
  PAPER = 'paper',
  COFFEE = 'coffee',
  CHEMISTRY = 'chemistry',
  OTHER_EQUIPMENT = 'other_equipment',
  FRESHENERS = 'fresheners',
  GARBAGE_BAGS = 'garbage_bags',
  SOAP = 'soap',
  BATTERIES = 'batteries',
  JUICES_CANDIES = 'juices_candies',
  COMPUTER_EQUIPMENT = 'computer_equipment',
}
